var map = {
	"./centra-logo.svg": "217a",
	"./geins-logo.svg": "c018",
	"./google-merchant-logo.svg": "149f",
	"./link-logo.svg": "7c78",
	"./magento-logo.svg": "0034",
	"./shopify-logo.svg": "455b",
	"./shopline-logo.svg": "46fd",
	"./stripe-logo.svg": "c1c4",
	"./swish-logo.svg": "b107",
	"./woocommerce-logo.svg": "28b3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "17db";